export class FileDTO {
    constructor(coachId, fileName, fileTypeFormat, fileArrayBuffer) {
        this.coachId = coachId;
        this.fileName = fileName;
        this.fileTypeFormat = fileTypeFormat;
        this.fileArrayBuffer = fileArrayBuffer;
    }
}
